import { getBatchTopicKeywords } from '@op/services';
import { arrayToObj } from '@op/utils';
import { useCallback, useEffect, useState } from 'react';
import React from 'react';
import KeywordsModal from '../components/KeywordsModal';

export default function useBatchTopicKeyword({
  tierTopic,
  gameInfo,
  isRequest,
}: any) {
  let [loading, setLoading] = useState(false);
  let [apiError, setApiError] = useState(false);
  const [optionalKeywords, setOptionalKeywords] = useState<{
    [key: string]: any;
  }>({});

  function requestServer() {
    if (tierTopic && isRequest && gameInfo?.edition_unified_id) {
      setLoading(true);
      setApiError(false);
      setOptionalKeywords({});
      getBatchTopicKeywords({ ...gameInfo, l2_topics: tierTopic })
        .then((data: any) => {
          const info = arrayToObj(data?.list, (item) =>
            item?.l2_topic?.toLocaleLowerCase(),
          );
          setOptionalKeywords(info);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }

  useEffect(() => {
    requestServer();
  }, [tierTopic]);

  const [visible, setVisible] = useState(false);
  const [tier2Topic, setTier2Topic] = useState('');
  // const [tier2TopicData, setTier2TopicData] = useState(null);

  function openWindows(value: string, data = null) {
    setTier2Topic(value);
    setVisible(true);
  }

  const KeywordsModalElement = useCallback(
    ({ transTopic, gameInfo }: any) => {
      return (
        <KeywordsModal
          visible={visible}
          close={() => {
            setVisible(false);
            setTier2Topic('');
            // setTier2TopicData(null);
          }}
          tier2Topic={tier2Topic}
          propsGameInfo={gameInfo}
          useLocale
          propsTransTopic={transTopic}
          // localData={tier2TopicData}
        />
      );
    },
    [tier2Topic, visible, optionalKeywords],
  );

  return { optionalKeywords, openWindows, KeywordsModalElement };
}
